import AppConstants from '../constants/AppConstants';
import { getTotalPages } from './helper';

export const initialState = {
    list: [],
    page: 1,
    total: null,
    loading: false
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {

        case AppConstants.UTMS_SEARCH_START_LOADING:
            return {
                ...state,
                loading: true
            };

        case AppConstants.UTMS_SEARCH_SUCCESS:
            return {
                ...state,
                loading: false,
                list: action.items.items,
                page: action.items.page,
                total: getTotalPages(action.items.total, action.items.count)
            };

        case AppConstants.UTMS_CLEAR:
            return {
                ...state,
                ...initialState
            };

        default:
            return state;
    }
};
